import styled from "styled-components";
import { StyledModal } from "../shared/modal.styled";


export const SendReportModalStyled = styled(StyledModal)`
  .modal-dialog .modal-content {
    border: none;
    background: #F9F9FF;
    box-shadow: -10px 48.5967px 140px rgba(126, 123, 160, 0.5);

    .modal-header {
      display: flex;
      padding: 15px 15px 0 15px;
      border: none;
      justify-content: flex-end !important;
      button {
        flex: 0 0 16px;
        width: 16px;
        height: 16px;
        border: none;
        line-height: 0;
        background-color: transparent;
        cursor: pointer;
        padding: 0;
        color: var(--bllink-gray);
      }
    }
    
    .modal-header {
      direction: ltr;
    }
    
    .modal-body {
      padding: 0 40px 20px;

      h1 {
        margin-top: 0;
      }
      button {
        margin-top: 32px;
      }
      
      .send-report-modal {
        &-form {
          display: flex;
          flex-direction: column;
          gap: 8px;
          margin-top: 23px;
          
          .error {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
        
        &-select {
          text-align: start;
        }

        &-label {
          color: rgba(55, 54, 71, 0.7);
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          
          label {
            margin: 0 12px;
          }
        }
        
        &-form-button {
          padding-top: 0;
          text-align: end;
          
          input {
            height: 44px;
            width: 200px;
            font-size: 14px;
            line-height: 23px;
          }
        }
        
        &-checkbox {
          
          label {
            display: flex;
            flex-direction: row;
            flex-wrap: nowrap;
            margin-bottom: 8px;
            justify-content: flex-start;
            align-items: center;
          }
          
          span {
            font-size: 14px;
            line-height: 16px;
            font-weight: normal;
            margin: 0;
            padding: 0;
            text-align: start;
          }
        }
      }
    }
  }
`;
